// Delegación segura: captura clicks en el botón aunque tenga hijos internos
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".upsell-btn");
  if (!btn) return;

  e.preventDefault();

  let variantId;
  if (btn.dataset.variantId) {
    // Producto con una sola variante
    variantId = btn.dataset.variantId;
  } else if (btn.dataset.variantSelect) {
    // Producto con múltiples variantes
    const select = btn.closest(".cart-upsell-product").querySelector(".upsell-variant");
    if (select) variantId = select.value;
  }

  if (!variantId) return;

  // Estado de cargando para evitar dobles clics
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.setAttribute("aria-busy", "true");
  btn.textContent = "Adding…";

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    credentials: "same-origin",
    // ✅ Enviar como string, no Number()
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(async (res) => {
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const msg = (data && (data.message || data.description)) || "Could not add item.";
        throw new Error(msg);
      }
      return data;
    })
    .then((data) => {
      console.log("✅ Upsell added:", data);

      // 🔹 Esconder el upsell agregado
      const productBox = btn.closest(".cart-upsell-product");
      if (productBox) {
        productBox.style.display = "none";
      }

      // 1) Intenta utilizar el drawer de Warehouse
      try {
        if (window.Shopify && Shopify.theme && Shopify.theme.cartDrawer) {
          if (typeof Shopify.theme.cartDrawer.open === "function") {
            Shopify.theme.cartDrawer.open();
          }
          if (typeof Shopify.theme.cartDrawer.render === "function") {
            Shopify.theme.cartDrawer.render();
          }
        }
      } catch (err) {
        console.warn("cartDrawer refresh failed:", err);
      }

      // 2) Dispara eventos que muchos temas escuchan
      try {
        window.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        window.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      } catch (err) {}

      // 3) Fallback duro: recargar si nada actualiza la UI
      setTimeout(function () {
        btn.disabled = false;
        btn.removeAttribute("aria-busy");
        btn.textContent = originalText;
        if (!document.documentElement.classList.contains("cart-drawer-open")) {
          location.reload();
        }
      }, 300);
    })
    .catch((err) => {
      console.error("❌ Error adding upsell:", err);
      alert(err.message || "Error adding item.");
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
      btn.textContent = originalText;
    });
});

